export const sessionExpiry = 'Your session has expired. Please login again.';

export const errorMessageRequired = 'This field is required.';
export const errorMessageEmailInvalid = 'Invalid e-mail address.';
export const errorMessageEmailListInvalid =
  'Invalid e-mail list, please enter a valid e-mail list. Example: email1@email.com,email2@email.com';
export const errorMessageConfirmPassword = 'Please enter the same password.';
export const errorMessagePasswordShort = 'Password is too short.';
export const errorMessagePasswordStrength =
  'Password must have lowercase / uppercase letters, a number and / or symbol.';
export const errorMessagePhoneNumberInvalid = 'Invalid phone number.';
export const errorMessageRecaptchaFailed = 'Recaptcha verification failed, refresh your browser and try again.';
export const errorMessageIncognito =
  'Your browser does not appear to have permission to do that. Are you in incognito / private mode?';
export const errorMessageFileType =
  'Invalid file, please upload a valid file that matches the file type specification.';
export const errorMessageZipCode = 'Invalid postal/ZIP code.';
export const errorMessageAccountPending = 'This account is pending approval, please check back later.';
export const errorMessageAccountDenied = 'This account has been blocked from accessing the system.';
export const errorMessageIncorrectCredentials = 'Incorrect credentials. Please try again.';
export const errorMessagePasswordResetNotFound = 'Token not found. Please request another reset.';
export const errorMessagePasswordResetLinkExpired = 'This password reset link has expired or has already been used.';
export const errorMessageRefreshTokenInvalid = 'Invalid token.';
export const errorMessageEmailExists = 'Email already exists.';
export const errorMessageSessionExpired = 'Session has expired. Please login again.';
